/**
 * CofferCard Live Demo Campaigns Definition & Helpers
 * Provides 100% reliable, offline-capable, instant interactive demo experiences
 * for all 4 game types: Spin the Wheel, Scratch Card, Mystery Box, and Slot Machine.
 */

export const DEMO_CAMPAIGNS = {
    // 1. Summer Lucky Spin & Win
    'f9b71223-965b-43a2-9879-1534b39c2f98': {
        id: 99901,
        unique_code: 'f9b71223-965b-43a2-9879-1534b39c2f98',
        name: 'Summer Lucky Spin & Win',
        type: 'spin',
        show_social_page: false,
        guidelines: 'Spin the lucky wheel for instant prizes, store discounts, and vouchers.',
        is_in_store: false,
        spins_per_user: 999,
        max_spins_per_ip: 99999,
        start_date: '2020-01-01T00:00:00Z',
        end_date: '2035-12-31T23:59:59Z',
        design_settings: {
            theme_style: 'modern',
            primary_color: '#D97706',
            secondary_color: '#F59E0B',
            bg_style: 'theme_default',
            bg_solid_color: '#FFFFFF',
            font_family: 'display',
            badge_text: 'LIVE INTERACTIVE DEMO',
            card_style: 'solid',
            headline: 'Summer Lucky Spin & Win',
            subheadline: 'Spin the lucky wheel for instant store prizes and discounts!',
            store_url: 'https://coffercard.com',
            cta_text: 'Redeem & Shop Now',
            unlock_badge: 'Live Interactive Demo',
            unlock_headline: 'Try CofferCard Live Game',
            unlock_subheadline: 'Experience instant winning moments just like your store customers will.',
            guidelines_title: 'Demo Guidelines',
            unlock_btn_text: 'Spin the Wheel Now'
        },
        vendor_name: 'CofferCard Artisan Cafe & Store',
        vendor_logo: null,
        all_winning_exhausted: false,
        prizes: [
            { id: 901, name: 'Free Artisan Coffee', description: 'Freshly brewed specialty single-origin roast', is_winning: true, quantity: 500, redeemed_count: 12, remaining_quantity: 488, is_exhausted: false, coupon_code: 'DEMO-COFFEE-FREE', probability: 25.0 },
            { id: 902, name: '20% OFF Entire Order', description: 'Valid across all menu items and merchandise', is_winning: true, quantity: 500, redeemed_count: 35, remaining_quantity: 465, is_exhausted: false, coupon_code: 'DEMO-SAVE-20', probability: 25.0 },
            { id: 903, name: 'Buy 1 Get 1 Free', description: 'Double your treats on any handcrafted drink', is_winning: true, quantity: 500, redeemed_count: 18, remaining_quantity: 482, is_exhausted: false, coupon_code: 'DEMO-BOGO-TREAT', probability: 20.0 },
            { id: 904, name: '₹100 Instant Voucher', description: 'Instant discount at billing counter', is_winning: true, quantity: 500, redeemed_count: 40, remaining_quantity: 460, is_exhausted: false, coupon_code: 'DEMO-CASH-100', probability: 15.0 },
            { id: 905, name: 'Better Luck Next Time', description: 'Thank you for playing! Try your luck again!', is_winning: false, quantity: 9999, redeemed_count: 0, remaining_quantity: 9999, is_exhausted: false, coupon_code: null, probability: 15.0 }
        ]
    },

    // 2. Mystery Scratch & Save
    '098d6769-7565-471f-b406-12b45b4d7817': {
        id: 99902,
        unique_code: '098d6769-7565-471f-b406-12b45b4d7817',
        name: 'Mystery Scratch & Save',
        type: 'scratch',
        show_social_page: false,
        guidelines: 'Scratch the foil surface to reveal your exclusive instant discount voucher.',
        is_in_store: false,
        spins_per_user: 999,
        max_spins_per_ip: 99999,
        start_date: '2020-01-01T00:00:00Z',
        end_date: '2035-12-31T23:59:59Z',
        design_settings: {
            theme_style: 'modern',
            primary_color: '#7C3AED',
            secondary_color: '#F59E0B',
            bg_style: 'theme_default',
            bg_solid_color: '#FFFFFF',
            font_family: 'display',
            badge_text: 'LIVE INTERACTIVE DEMO',
            card_style: 'solid',
            headline: 'Mystery Scratch & Save',
            subheadline: 'Scratch the card below to reveal your surprise reward voucher!',
            store_url: 'https://coffercard.com',
            cta_text: 'Redeem & Shop Now',
            unlock_badge: 'Live Interactive Demo',
            unlock_headline: 'Try Scratch & Win Demo',
            unlock_subheadline: 'Interactive scratch card simulation with instant reward reveal.',
            guidelines_title: 'Demo Guidelines',
            unlock_btn_text: 'Start Scratching'
        },
        vendor_name: 'CofferCard Artisan Store',
        vendor_logo: null,
        all_winning_exhausted: false,
        prizes: [
            { id: 911, name: '25% OFF Voucher', description: 'Instant discount on your entire shopping cart', is_winning: true, quantity: 500, redeemed_count: 10, remaining_quantity: 490, is_exhausted: false, coupon_code: 'DEMO-SCRATCH-25', probability: 30.0 },
            { id: 912, name: 'Free Donut with Coffee', description: 'Delicious freshly glazed donut pairing', is_winning: true, quantity: 500, redeemed_count: 22, remaining_quantity: 478, is_exhausted: false, coupon_code: 'DEMO-DONUT-TREAT', probability: 25.0 },
            { id: 913, name: '₹150 Super Saver Voucher', description: 'Redeemable in-store or online anytime', is_winning: true, quantity: 500, redeemed_count: 15, remaining_quantity: 485, is_exhausted: false, coupon_code: 'DEMO-SAVE-150', probability: 25.0 },
            { id: 914, name: 'Almost Won! Try Again', description: 'Better luck on your next scratch attempt!', is_winning: false, quantity: 9999, redeemed_count: 0, remaining_quantity: 9999, is_exhausted: false, coupon_code: null, probability: 20.0 }
        ]
    },

    // 3. VIP Mystery Box
    'd124eaaa-9d57-4d5e-b75c-bcf25a23f048': {
        id: 99903,
        unique_code: 'd124eaaa-9d57-4d5e-b75c-bcf25a23f048',
        name: 'VIP Mystery Box',
        type: 'box',
        show_social_page: false,
        guidelines: 'Tap any 3D gift box to unwrap rewards, special perks, and surprise vouchers.',
        is_in_store: false,
        spins_per_user: 999,
        max_spins_per_ip: 99999,
        start_date: '2020-01-01T00:00:00Z',
        end_date: '2035-12-31T23:59:59Z',
        design_settings: {
            theme_style: 'modern',
            primary_color: '#D97706',
            secondary_color: '#F59E0B',
            bg_style: 'theme_default',
            bg_solid_color: '#FFFFFF',
            font_family: 'display',
            badge_text: 'LIVE INTERACTIVE DEMO',
            card_style: 'solid',
            headline: 'VIP Mystery Box',
            subheadline: 'Choose a lucky box to unwrap surprise rewards & gifts!',
            store_url: 'https://coffercard.com',
            cta_text: 'Redeem & Shop Now',
            unlock_badge: 'Live Interactive Demo',
            unlock_headline: 'Try Mystery Box Demo',
            unlock_subheadline: 'Interactive 3D gift unboxing with celebratory fanfare.',
            guidelines_title: 'Demo Guidelines',
            unlock_btn_text: 'Open a Box Now'
        },
        vendor_name: 'CofferCard Rewards Club',
        vendor_logo: null,
        all_winning_exhausted: false,
        prizes: [
            { id: 921, name: 'Surprise Gift Card ₹200', description: 'Valid across all store items', is_winning: true, quantity: 500, redeemed_count: 14, remaining_quantity: 486, is_exhausted: false, coupon_code: 'DEMO-BOX-200', probability: 30.0 },
            { id: 922, name: 'Free Chef Dessert Platter', description: 'Handcrafted sweet treat on your visit', is_winning: true, quantity: 500, redeemed_count: 19, remaining_quantity: 481, is_exhausted: false, coupon_code: 'DEMO-DESSERT-WIN', probability: 30.0 },
            { id: 923, name: '15% Loyalty Discount', description: 'Exclusive thank-you discount', is_winning: true, quantity: 500, redeemed_count: 25, remaining_quantity: 475, is_exhausted: false, coupon_code: 'DEMO-VIP-15', probability: 25.0 },
            { id: 924, name: 'Empty Box! Try Again', description: 'Better luck on your next unbox!', is_winning: false, quantity: 9999, redeemed_count: 0, remaining_quantity: 9999, is_exhausted: false, coupon_code: null, probability: 15.0 }
        ]
    },

    // 4. Lucky 777 Jackpot Slots
    '6588c1e5-ed43-4dba-a6f1-10efd0de95ed': {
        id: 99904,
        unique_code: '6588c1e5-ed43-4dba-a6f1-10efd0de95ed',
        name: 'Lucky 777 Jackpot Slots',
        type: 'slot',
        show_social_page: false,
        guidelines: 'Pull the casino lever and match 3 reels to hit the mega store discount jackpot.',
        is_in_store: false,
        spins_per_user: 999,
        max_spins_per_ip: 99999,
        start_date: '2020-01-01T00:00:00Z',
        end_date: '2035-12-31T23:59:59Z',
        design_settings: {
            theme_style: 'modern',
            primary_color: '#E11D48',
            secondary_color: '#F59E0B',
            bg_style: 'theme_default',
            bg_solid_color: '#FFFFFF',
            font_family: 'display',
            badge_text: 'LIVE INTERACTIVE DEMO',
            card_style: 'solid',
            headline: 'Lucky 777 Jackpot Slots',
            subheadline: 'Pull the lever and spin the reels for instant store rewards!',
            store_url: 'https://coffercard.com',
            cta_text: 'Redeem & Shop Now',
            unlock_badge: 'Live Interactive Demo',
            unlock_headline: 'Try Slot Machine Demo',
            unlock_subheadline: 'Casino-grade 3-reel slot spinner that drives store visits.',
            guidelines_title: 'Demo Guidelines',
            unlock_btn_text: 'Pull Lever Now'
        },
        vendor_name: 'CofferCard Arcade Store',
        vendor_logo: null,
        all_winning_exhausted: false,
        prizes: [
            { id: 931, name: '777 Mega Jackpot: ₹500 OFF', description: 'Triple 7s hit! Massive store discount voucher', is_winning: true, quantity: 500, redeemed_count: 5, remaining_quantity: 495, is_exhausted: false, coupon_code: 'DEMO-JACKPOT-777', probability: 25.0 },
            { id: 932, name: 'Double Cherries: 20% OFF', description: 'Cherry match reward voucher', is_winning: true, quantity: 500, redeemed_count: 18, remaining_quantity: 482, is_exhausted: false, coupon_code: 'DEMO-CHERRY-20', probability: 30.0 },
            { id: 933, name: 'Gold Bells: Free Drink', description: 'Complimentary handcrafted beverage', is_winning: true, quantity: 500, redeemed_count: 21, remaining_quantity: 479, is_exhausted: false, coupon_code: 'DEMO-BELLS-FREE', probability: 25.0 },
            { id: 934, name: 'Spin Again Tomorrow!', description: 'No match this time, try again tomorrow!', is_winning: false, quantity: 9999, redeemed_count: 0, remaining_quantity: 9999, is_exhausted: false, coupon_code: null, probability: 20.0 }
        ]
    }
};

export const DEMO_ALIAS_MAP = {
    'demo': 'f9b71223-965b-43a2-9879-1534b39c2f98',
    'demo-spin': 'f9b71223-965b-43a2-9879-1534b39c2f98',
    'demo-scratch': '098d6769-7565-471f-b406-12b45b4d7817',
    'demo-box': 'd124eaaa-9d57-4d5e-b75c-bcf25a23f048',
    'demo-slot': '6588c1e5-ed43-4dba-a6f1-10efd0de95ed',
};

export const DEMO_GAMES = [
    {
        id: 'spin-demo',
        code: 'f9b71223-965b-43a2-9879-1534b39c2f98',
        name: 'Summer Lucky Spin & Win',
        type: 'spin',
        tagline: 'Spin the lucky wheel for instant prizes and store discounts'
    },
    {
        id: 'scratch-demo',
        code: '098d6769-7565-471f-b406-12b45b4d7817',
        name: 'Mystery Scratch & Save',
        type: 'scratch',
        tagline: 'Scratch to reveal your instant reward voucher'
    },
    {
        id: 'box-demo',
        code: 'd124eaaa-9d57-4d5e-b75c-bcf25a23f048',
        name: 'VIP Mystery Box',
        type: 'box',
        tagline: 'Tap to unwrap surprise gifts, vouchers, and store treats'
    },
    {
        id: 'slot-demo',
        code: '6588c1e5-ed43-4dba-a6f1-10efd0de95ed',
        name: 'Lucky 777 Jackpot Slots',
        type: 'slot',
        tagline: 'Pull the lever and match 3 reels to hit the jackpot'
    }
];

export const isDemoCode = (code) => {
    if (!code) return false;
    const c = String(code).trim().toLowerCase();
    if (DEMO_CAMPAIGNS[c] || DEMO_ALIAS_MAP[c]) return true;
    if (c.startsWith('demo') || c.includes('demo')) return true;
    return false;
};

export const getDemoCampaign = (code) => {
    if (!code) return DEMO_CAMPAIGNS['f9b71223-965b-43a2-9879-1534b39c2f98'];
    const c = String(code).trim().toLowerCase();
    const targetCode = DEMO_ALIAS_MAP[c] || c;
    if (DEMO_CAMPAIGNS[targetCode]) {
        return DEMO_CAMPAIGNS[targetCode];
    }
    if (c.includes('scratch')) return DEMO_CAMPAIGNS['098d6769-7565-471f-b406-12b45b4d7817'];
    if (c.includes('box')) return DEMO_CAMPAIGNS['d124eaaa-9d57-4d5e-b75c-bcf25a23f048'];
    if (c.includes('slot')) return DEMO_CAMPAIGNS['6588c1e5-ed43-4dba-a6f1-10efd0de95ed'];
    return DEMO_CAMPAIGNS['f9b71223-965b-43a2-9879-1534b39c2f98'];
};

export const getRandomDemoPrize = (code) => {
    const campaign = getDemoCampaign(code);
    const prizes = campaign.prizes;
    const totalWeight = prizes.reduce((sum, p) => sum + (p.probability || 20), 0);
    const rand = Math.random() * totalWeight;
    let cumulative = 0;
    for (const p of prizes) {
        cumulative += (p.probability || 20);
        if (rand <= cumulative) return p;
    }
    return prizes[0];
};
